// utils/boatTypes.ts
export interface BoatTypeOption {
  label: string;
}

// Export available boat types
export const boatTypes: BoatTypeOption[] = [
  { label: "All types" },
  { label: "Sailboat" },
  { label: "Motor boat" },
  { label: "Catamaran" },
  { label: "Gulet" },
];

// use if else instead of switch
export const getBoatStatus = (status: number | string) => {
  const s = status === "B" ? "B" : Number(status);
  if (s === 0) {
    return {
      title: "Confirmed Availability",
      description:
        "Updated availability and pricing. You can book immediately.",
      color: "green",
    };
  } else if (s === 1) {
    return {
      title: "Reservation",
      description: "Already reserved, not available.",
      color: "red",
    };
  } else if (s === 2) {
    return {
      title: "Option opened for another client",
      description: "Send us your request now to add yourself to the queue.",
      color: "orange",
    };
  } else if (s === 3) {
    return {
      title: "Option in expiration",
      description: "Option expires soon.",
      color: "yellow",
    };
  } else if (s === 4) {
    return {
      title: "Service",
      description: "The boat is currently in service.",
      color: "blue",
    };
  } else if (s === "B") {
    return {
      title: "Sleepaboard",
      description:
        "You can sleep on the boat the night before the departure date.",
      color: "purple",
    };
  } else {
    return {};
  }
};
